module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n    Temperature Graph\n  ")]), _vm._v(" "), _c('temperature-ranges'), _vm._v(" "), _c('chart', {
    ref: "temperatureChart",
    attrs: {
      "options": _vm.line
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24240b7e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TemperatureGraph.vue
// module id = 372
// module chunks = 1